<template>
  <div>
    <div class="crm-info section person-cases-section">
      <div class="section-title">
        <div class="osobe-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="32"
            viewBox="0 0 20 32"
          >
            <g>
              <g>
                <path
                  d="M12.19 6.376a3.736 3.736 0 0 1 3.732-3.732 3.736 3.736 0 0 1 3.732 3.732 3.736 3.736 0 0 1-3.732 3.732 3.736 3.736 0 0 1-3.732-3.732zm2.488 0c0 .686.558 1.244 1.244 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.686 0-1.244.558-1.244 1.244zm7.463 8.645v5.473a3.738 3.738 0 0 1-2.487 3.519v6.743a1.244 1.244 0 1 1-2.488 0v-7.774c0-.687.557-1.244 1.244-1.244.685 0 1.244-.558 1.244-1.244v-5.473c0-.686-.559-1.244-1.244-1.244h-2.24a1.244 1.244 0 1 1 0-2.488h2.24a3.736 3.736 0 0 1 3.731 3.732zM0 12.533a3.736 3.736 0 0 1 3.732-3.732h4.975a3.736 3.736 0 0 1 3.732 3.732v6.78c0 .463-.086.908-.24 1.318a1.245 1.245 0 0 0 1.235 1.107c.687 0 1.244.557 1.244 1.244v7.774a1.244 1.244 0 0 1-2.488 0v-6.743a3.75 3.75 0 0 1-1.804-1.37c-.14.072-.285.135-.435.188v7.925a1.244 1.244 0 1 1-2.488 0V21.8c0-.687.557-1.244 1.244-1.244.686 0 1.244-.558 1.244-1.244v-6.779c0-.686-.558-1.244-1.244-1.244H3.732c-.686 0-1.244.558-1.244 1.244v6.78c0 .685.558 1.243 1.244 1.243.687 0 1.244.557 1.244 1.244v8.956a1.244 1.244 0 1 1-2.488 0v-7.912A3.739 3.739 0 0 1 0 19.325zm2.488-8.645A3.736 3.736 0 0 1 6.219.156a3.736 3.736 0 0 1 3.732 3.732A3.736 3.736 0 0 1 6.22 7.62a3.736 3.736 0 0 1-3.731-3.732zm2.488 0c0 .686.558 1.244 1.243 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.685 0-1.243.558-1.243 1.244z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        {{ $t('crm.info.title') }}
        <div class="generiraj-rocisnik-button" @click="popEditModal()">
          <span>{{ $t('crm.info.edit') }}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 13 13"
          >
            <g>
              <g>
                <path
                  fill="#7b7b8a"
                  d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
      </div>

      <div class="crm-info-part edit-crm">
        <div class="case-info-item">
          <div class="case-info-item-title">{{ $t('crm.info.status') }}</div>
          <div :class="'crm-status ' + person_crm_data.crm_client_status.color">
            {{ person_crm_data.crm_client_status.name }}
          </div>
        </div>

        <div class="case-info-item">
          <div class="case-info-item-title">{{ $t('crm.info.sales_lead') }}</div>
          <div class="case-info-item-info">
            <span v-if="!person_crm_data.odvjetnik">{{ $t('crm.info.not_assigned') }}</span>
            <router-link :to="'/osobe/law/'+person_crm_data.lead_handler" v-else>{{person_crm_data.odvjetnik.ime}} {{person_crm_data.odvjetnik.prezime}}</router-link>
          </div>
        </div>
      </div>
    </div>
    <crm-edit-info
      v-if="edit_data_modal"
      @closeMe="closePop"
      @edit="updateCrm"
      :old_data="person_crm_data"
      :sales_status_list = "sales_status_list"
      :clanovi="all_users"
    ></crm-edit-info>
  </div>
</template>

<script>
import admin from "@/apiCallers/promise_handler_db/admin.js";

import CrmEditInfo from "./CrmEditInfo.vue";
import { fetchAllSalesStatus, updateCrmStatus } from '../../apiCallers/promise_handler_db/crm';
export default {
  components: { CrmEditInfo },
  name: "CrmInfo",
  props: {
    person_crm_data: Object,
    person_id: String,
    person_type: String,
  },

  data() {
    return {
      edit_data_modal: false,
      all_users: [],
      sales_status_list : []
    };
  },
  methods: {
    closePop(){
      this.edit_data_modal = false
    },
    async updateCrm(new_data)
    { 
      console.log(new_data)
      this.edit_data_modal = false
      await updateCrmStatus(new_data, this.person_id, this.person_type).then(()=>{
              this.$emit("refreshData")

      })
    },
    async getAllCrmStatuses()
    {
       await fetchAllSalesStatus().then((resp)=>{
        this.sales_status_list = resp.map((p) => {
          return {  naziv: p.name,
                      id: p.id,};
        });
       })
    },
    async getAllUsers() {
      await admin.getUsers().then((resp) => {
        this.all_users = resp.data.all_users.map((p) => {
          return { value: p.ime + " " + p.prezime, link: p.uid };
        });
      });
    },
    popEditModal() {
      this.edit_data_modal = true;
    },
  },

  mounted(){
    this.getAllUsers();
    this.getAllCrmStatuses()
  }
};
</script>

<style></style>
